import React, { useEffect } from 'react';
import { FormField as FormFieldType, FormData, FormFiles, FormErrors, GenericFieldType } from '../../../../../types/ContactForm';
import { resolveGenericFieldValue } from '../../../../../helpers/resolveGenericFieldValue';

interface GenericFieldProps {
    field: FormFieldType;
    formData: FormData;
    files: FormFiles;
    errors: FormErrors;
    inputCssClass?: string;
    genericFieldValues?: Partial<Record<GenericFieldType, string>>;
    onInputChange: (name: string, value: string) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const GenericField: React.FC<GenericFieldProps> = ({ field, genericFieldValues, onInputChange }) => {
    const resolvedValue = resolveGenericFieldValue(field.genericType, genericFieldValues);

    useEffect(() => {
        if (resolvedValue) {
            onInputChange(field.name, resolvedValue);
        }
    }, [field.name, resolvedValue]);

    if (!resolvedValue) {
        return null;
    }

    return (
        <input
            type="hidden"
            name={field.name}
            value={resolvedValue}
            readOnly
        />
    );
};
